import * as Namespaces from "./namespaces";

const locales = {
  [Namespaces.PAGE_LOGIN]: {
    el: {
      Connection: "Σύνδεση",
      "Account Connection": "ΣΥΝΔΕΣΗ ΛΟΓΑΡΙΑΣΜΟΥ",
      "Enter your username": "Εισάγετε το όνομα χρήστη",
      "Dont have an account": "Δεν εχετε λογαριασμο;",
      "Register Here": "Κάντε εγγραφή εδώ",
      Password: "Κωδικός",
      Login: "ΕΙΣΟΔΟΣ",
      Required: "Απαιτείται",
      "Forgot password? Click here.": "Ξεχάσατε τον κωδικό σας; Πατήστε εδώ.",
      Cancel: "Ακύρωση",
      "Password reset": "Ανάκτηση Κωδικού",
      reset_password:
        "Για να δηλώσετε νέο κωδικό, παρακαλώ εισάγετε το email σας εδώ. Θα λάβετε στο email σας έναν εξαψήφιο κωδικό. <br/> Χρησιμοποιείστε τον εξαψήφιο κωδικό για να δηλώσετε τον νέο κωδικό σας.",
      "Not Found": "Το email που καταχωρήθηκε δεν υπάρχει.",
      reset_success:
        "Ο κωδικός σας έχει αλλάξει επιτυχώς. Προχωρήστε στη σύνδεση με τον νέο κωδικό σας.",
      request_new_pass_success:
        "Ο εξαψήφιος κωδικός έχει αποσταλεί επιτυχώς στο email σας. Αν δεν βλέπετε το email, παρακαλώ ελέγξτε τους φακέλους των SPAM ή JUNK emails.",
      "Password must be between 7-16 latin characters and contain at least 3 of the following. -Upper case character -Lower case character -Numeric digit -Special character":
        "Ο κωδικός πρόσβασης πρέπει να αποτελείται από 7-16 λατινικούς χαρακτήρες και να περιέχει τουλάχιστον 3 από τα ακόλουθα. -Κεφάλαιο -Πεζό χαρακτήρα -Αριθμητικό ψηφίο -Ειδικός χαρακτήρας",
      "Passwords must match": "Οι κωδικοί πρέπει να ταιριάζουν",
      "Six digit code": "Εξαψήφιος κωδικός",
      "New password": "Νέος κωδικός",
      "Confirm password": "Επαλήθευση κωδικού",
      "Submit New Password": "Υποβολή Νέου Κωδικού",
      "Send 6 Digit Code": "Αποστολή Εξαψήφιου Κωδικού",
      "Connection to API failed!": "Η επικοινωνία με το API απέτυχε!",
      "Insert a valid email": "Εισάγετε ένα έγκυρο email",
      "Wrong 6 digit password!": "Μη έγκυρος ή ληγμένος εξαψήφιος κωδικός!",
      "Enter your email": "Εισαγωγή email",
      "msg.login_notfound": "Λανθασμένα στοιχεία πρόσβασης",
      "An error occurred!": "Παρουσιάστηκε σφάλμα!",
      "CREATE ACCOUNT":"ΔΗΜΙΟΥΡΓΙΑ ΛΟΓΑΡΙΑΣΜΟΥ",
      "Do you have an account already?":"Έχεις ήδη λογαριασμό?",
      "Log in here":"Συνδεθείτε εδώ",
      "Name":"Όνομα",
      "AFM":"ΑΦΜ",
      "Company":"Εταιρεία",
      "Country":"Χώρα",
      "Phone":"Τηλέφωνο",
      "Confirm Password":"Επιβεβαίωση κωδικού",
      "Register to our newsletter":"Εγγραφή/ήδη στο newsletter μας!",
      "Receive special offers from our partners!":"Λάβετε ειδικές προσφορές από τους συνεργάτες μας!",
      "Read and confirm the terms and conditions and privacy policy":"Διάβασα και αποδέχομαι τους όρους χρήσης και την πολιτική απορρήτου",
      'Save':"Αποθήκευση",
      "Greece":"Ελλάδα",
      "Cyprus":"Κύπρος",
      "Cafeteria":"Καφεστίαση",
      "Hotel units":"Ξενοδοχειακές μονάδες",
      "Offices / Companies":"Γραφεία / Εταιρείες",
      'User was successfully submitted!':"Ο χρήστης καταχωρήθηκε με επιτυχία!",
      'Do not have an account?':"Δεν έχεις λογαριασμό?",
      'Sign up here':"Εγγραφείτε εδώ",
      "Username":"όνομα χρήστη",
      'Remember me':"Θυμήσου με",
      'Forgot your password?':'Ξέχασες τον κωδικό σου?'

    },
    en: {
      Connection: "Connection",
      "Account Connection": "Account Connection",
      "Enter your username": "Enter your username",
      "Dont have an account": "Don't have an account?",
      "Register Here": "Register Here",
      Password: "Password",
      Login: "Login",
      Required: "Required",
      "Forgot password? Click here.": "Forgot password? Click here.",
      Cancel: "Cancel",
      "Password reset": "Password Reset",
      reset_password:
        "To set a new password, please enter your email here. You will receive a six-digit code in your email. <br/> Use the six-digit code to set your new password.",
      "Not Found": "Email not found.",
      reset_success: "Password reset successful. Please proceed to login.",
      request_new_pass_success:
        "The 6 digit code was successfully send to your email. If you cannot find this email, please check SPAM or JUNK folders in your email provider.",
      "Password must be between 7-16 latin characters and contain at least 3 of the following. -Upper case character -Lower case character -Numeric digit -Special character":
        "Password must be between 7-16 latin characters and contain at least 3 of the following: -Upper case character -Lower case character -Numeric digit -Special character",
      "Passwords must match": "Passwords must match",
      "Six digit code": "Six digit code",
      "New password": "New password",
      "Confirm password": "Confirm password",
      "Submit New Password": "Submit New Password",
      "Send 6 Digit Code": "Send 6 Digit Code",
      "Connection to API failed!": "Connection to API failed!",
      "Insert a valid email": "Insert a valid email",
      "Wrong 6 digit password!": "Invalid or expired six-digit code!",
      "Enter your email": "Enter your email",
      "msg.login_notfound": "Incorrect Login Credentials",
      "An error occurred!": "An error occurred!",
    },
  },
  [Namespaces.PAGE_HOME]: {
    el: {
      Welcome: "Καλώς ήρθατε",
      Dashboard: "Πίνακας Ελέγχου",
      Home: "Αρχική",
      Logout: "Αποσύνδεση",
      Profile: "Προφίλ",
      Settings: "Ρυθμίσεις",
      Overview: "Επισκόπηση",
      "Quick Actions": "Γρήγορες Ενέργειες",
      "Recent Orders": "Πρόσφατες Παραγγελίες",
      Statistics: "Στατιστικά",
      "View All": "Προβολή Όλων",
      "VIEW PRODUCTS":"Δείτε τα προιόντα",
      "OUR PRODUCTS":"Τα προιόντα μας",
      "THIS IS A BIG TITLE FOR BREW PRODUCTS":"ΈΝΑΣ ΤΊΤΛΟΣ ΓΙΑ ΤΑ ΠΡΟΙΟΝΤΑ BREW",
      "SCALES":"ΖΥΓΑΡΙΕΣ",
      "COFFEE":"ΚΑΦΕΔΕΣ",
      "FILTERS":"ΦΙΛΤΡΑ",
      "SPECIAL OFFERS":"ΕΙΔΙΚΕΣ ΠΡΟΣΦΟΡΕΣ",
      "NEW PRODUCTS":"ΝΕΑ ΠΡΟΪΟΝΤΑ",
      "ABOUT US":"ΣΧΕΤΙΚΑ ΜΕ ΕΜΑΣ",
      "There are no products to display":"Δεν υπάρχουν προϊόντα προς εμφάνιση",
      "All products":"'Ολα τα προΪόντα",
      "About us":"Σχετικά με εμάς"
    },
    en: {
      Welcome: "Welcome",
      Dashboard: "Dashboard",
      Home: "Home",
      Logout: "Logout",
      Profile: "Profile",
      Settings: "Settings",
      Overview: "Overview",
      "Quick Actions": "Quick Actions",
      "Recent Orders": "Recent Orders",
      Statistics: "Statistics",
      "View All": "View All",
    },
  },
  [Namespaces.NOT_FOUND]: {
    el: {
      "The page you are looking was moved, removed, renamed, or might never existed!":
        "Η σελίδα που ψάχνετε μετακινήθηκε, αφαιρέθηκε, μετονομάστηκε ή μπορεί να μην υπήρξε ποτέ!",
      "Back To Home": "Επιστροφή στην Αρχική",
      "Page Not Found": "Η σελίδα δε`ν βρέθηκε",
      "Error 404": "Σφάλμα 404",
      "Go Home": "Επιστροφή στο Home",
      "It seems": "ΦΑΙΝΕΤΑΙ ΟΤΙ ΑΥΤΗ Η ΣΕΛΙΔΑ ΔΕΝ ΕΙΝΑΙ ΠΛΕΟΝ ΔΙΑΘΕΣΙΜΗ.",
      Suggests: "Μπορείτε να επισκεφτείτε τις παρακάτω ενότητες.",
      "HOME PAGE": "ΑΡΧΙΚΗ ΣΕΛΙΔΑ",
      "BREW PRODUCTS": "ΠΡΟΙΟΝΤΑ BREW",
      "LUNOR PRODUCTS": "ΠΡΟΙΟΝΤΑ LUNOR",
    },
    en: {
      "The page you are looking was moved, removed, renamed, or might never existed!":
        "The page you are looking for was moved, removed, renamed, or might never existed!",
      "Back To Home": "Back To Home",
      "Page Not Found": "Page Not Found",
      "Error 404": "Error 404",
      "Go Home": "Go Home",
      "It seems": "it seems that the page you are looking is not available.",
      Suggests: "You can visit the following sections.",
      "HOME PAGE": "HOME PAGE",
      "BREW PRODUCTS": "BREW PRODUCTS",
      "LUNOR PRODUCTS": "LUNOR PRODUCTS",
    },
  },
  [Namespaces.ORDERS]: {
    el: {
      Orders: "Παραγγελίες",
      "My Orders": "Οι Παραγγελίες Μου",
      "Order ID": "ID Παραγγελίας",
      "Order Date": "Ημερομηνία Παραγγελίας",
      Total: "Σύνολο",
      Status: "Κατάσταση",
      Pending: "Εκκρεμής",
      Processing: "Σε Επεξεργασία",
      Shipped: "Αποστάλη",
      Delivered: "Παραδόθη",
      Cancelled: "Ακυρώθηκε",
      "View Details": "Προβολή Λεπτομερειών",
      "Track Order": "Παρακολούθηση Παραγγελίας",
      "No orders found": "Δεν βρέθηκαν παραγγελίες",
      "Start Shopping": "Ξεκινήστε τις Αγορές",
      "Failed to load orders": "Αποτυχία φόρτωσης παραγγελιών",
      Retry: "Επανάληψη",
    },
    en: {
      Orders: "Orders",
      "My Orders": "My Orders",
      "Order ID": "Order ID",
      "Order Date": "Order Date",
      Total: "Total",
      Status: "Status",
      Pending: "Pending",
      Processing: "Processing",
      Shipped: "Shipped",
      Delivered: "Delivered",
      Cancelled: "Cancelled",
      "View Details": "View Details",
      "Track Order": "Track Order",
      "No orders found": "No orders found",
      "Start Shopping": "Start Shopping",
      "Failed to load orders": "Failed to load orders",
      Retry: "Retry",
    },
  },
  [Namespaces.PRODUCTS_LIST]: {
    el: {
      Home: "Αρχική",
      Products: "Προϊόντα",
      "ALL PRODUCTS": "ΟΛΑ ΤΑ ΠΡΟΪΟΝΤΑ",
      Filters: "Φίλτρα",
      Categories: "ΚΑΤΗΓΟΡΙΕΣ",
      Brands: "ΜΑΡΚΑ",
      Colors: "ΧΡΩΜΑ",
      Price: "ΤΙΜΗ",
      From: "Από",
      To: "Έως",
      Min: "Ελάχιστο",
      Max: "Μέγιστο",
      Apply: "Εφαρμογή",
      "No products found": "Δεν βρέθηκαν προϊόντα",
      "Try adjusting your filters": "Δοκιμάστε να προσαρμόσετε τα φίλτρα σας",
      "Add to Cart": "Προσθήκη στο Καλάθι",
      "Add to Favorites": "Προσθήκη στα Αγαπημένα",
      "Remove from Favorites": "Αφαίρεση από Αγαπημένα",
      "Quick View": "Γρήγορη Προβολή",
      Rating: "Αξιολόγηση",
      Reviews: "Κριτικές",
      "In Stock": "Διαθέσιμο",
      "Out of Stock": "Εξαντλημένο",
      "Failed to load filters":
        "Αποτυχία φόρτωσης φίλτρων. Παρακαλώ ανανεώστε τη σελίδα.",
      "Failed to load products":
        "Αποτυχία φόρτωσης προϊόντων. Παρακαλώ ανανεώστε τη σελίδα.",
      Loading: "Φόρτωση...",
      Page: "Σελίδα",
      of: "από",
      "Sort by": "Ταξινόμηση κατά",
      Newest: "Νέα",
      "Price ascending": "Αύξουσα τιμή",
      "Price descending": "Φθίνουσα τιμή",
      "Best Sellers": "Πιο Δημοφιλή",
      "Top Rated": "Κορυφαία Αξιολόγηση",
      ADD: "ΠΡΟΣΘΗΚΗ",
      "Clear Filters": "Καθαρισμός φίλτρων",
      "show more": "ΠΕΡΙΣΣΟΤΕΡΑ",
      "show less": "ΛΙΓΟΤΕΡΑ",
      'login':'Σύνδεση λογαριασμού',
      'Do not have an account?':'Δεν έχεις λογαριασμό?',
      'Sign up here':"Κάνε εγγραφή εδώ",
      'Forgot your password?':"Ξέχασες τον κωδικό σου?",
      'Login':'Είσοδος',
      'Add':'Προσθήκη',
      'Product is not available':'Το προϊόν δεν είναι διαθέσιμο',
      "without VAT":"χωρίς ΦΠΑ",
      "Description":"Περιγραφή",
      "Characteristics":"Χαρακτηριστικά",
      "See what others who viewed this product clicked next!":"Δες τι κλίκαραν όσοι είδαν το ίδιο προϊόν με εσένα!",

    },
    en: {
      Home: "Home",
      Products: "Products",
      "ALL PRODUCTS": "ALL PRODUCTS",
      Filters: "Filters",
      Categories: "Categories",
      Brands: "Brands",
      Colors: "Colors",
      Price: "Price",
      From: "From",
      To: "To",
      Min: "Min",
      Max: "Max",
      Apply: "Apply",
      "No products found": "No products found",
      "Try adjusting your filters": "Try adjusting your filters",
      "Add to Cart": "Add to Cart",
      "Add to Favorites": "Add to Favorites",
      "Remove from Favorites": "Remove from Favorites",
      "Quick View": "Quick View",
      Rating: "Rating",
      Reviews: "Reviews",
      "In Stock": "In Stock",
      "Out of Stock": "Out of Stock",
      "Failed to load filters":
        "Failed to load filters. Please refresh the page.",
      "Failed to load products":
        "Failed to load products. Please refresh the page.",
      Loading: "Loading...",
      Page: "Page",
      of: "of",
      "Sort by": "Sort by",
      Newest: "Newest",
      "Price ascending": "Price ascending",
      "Price descending": "Price descending",
      "Best Sellers": "Best Sellers",
      "Top Rated": "Top Rated",
      ADD: "ADD",
      "Clear Filters": "Clear Filters",
      "show more": "show more",
      "show less": "show less",
    },
  },
};

export default locales;
